import { render, staticRenderFns } from "./CopyserviceorderproductPage.vue?vue&type=template&id=0a893513&scoped=true"
import script from "./CopyserviceorderproductPage.vue?vue&type=script&lang=js"
export * from "./CopyserviceorderproductPage.vue?vue&type=script&lang=js"
import style0 from "./CopyserviceorderproductPage.vue?vue&type=style&index=0&id=0a893513&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a893513",
  null
  
)

export default component.exports